import { render, staticRenderFns } from "./UsersPrivilegeServiceReservationMedia.vue?vue&type=template&id=b602dc9a&scoped=true&"
import script from "./UsersPrivilegeServiceReservationMedia.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeServiceReservationMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b602dc9a",
  null
  
)

export default component.exports